import { render, staticRenderFns } from "./CreateGroupView.vue?vue&type=template&id=bebc9c9c&"
import script from "./CreateGroupView.vue?vue&type=script&lang=js&"
export * from "./CreateGroupView.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroupView.vue?vue&type=style&index=0&id=bebc9c9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports